import React from 'react';
import Chart from 'react-apexcharts';

const ChartCard = ({ title, series, labels }) => {
  return (
    <div className="bg-white px-6 py-1 rounded-2xl shadow-sm border border-gray-100">
      <p className="text-sm font-bold text-gray-600 uppercase mb-2">{title}</p>
      <Chart
        type="donut"
        height={200}
        series={series}
        options={{
          labels,
          legend: { position: 'right' },
          plotOptions: { pie: { donut: { size: '70%' } } },
          dataLabels: { enabled: false }
        }}
      />
    </div>
  );
};

const ProfitLossChart = ({ data, type }) => {
  if (!data) return null;

  if (type === "monthWise" && Array.isArray(data)) {
    if (data.length === 0) {
      return (
        <div className="bg-white p-10 text-center rounded-2xl border border-dashed border-gray-200 text-gray-400 mb-10">
          No trend data available for the selected period.
        </div>
      );
    }

    const barConfig = {
      series: [
        { name: 'Income', data: data.map(d => d.totalIncome || 0) },
        { name: 'Expense', data: data.map(d => d.totalExpense || 0) }
      ],
      options: {
        chart: { toolbar: { show: false } },
        colors: ['#10B981', '#EF4444'],
        xaxis: { categories: data.map(d => d.month) },
        plotOptions: { bar: { borderRadius: 4, columnWidth: '45%' } },
        dataLabels: { enabled: false },
        legend: { position: 'top' }
      }
    };

    return (
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-2">
        <p className="text-sm font-bold text-gray-600 uppercase mb-4">Monthly Profit & Loss Trend</p>
        <Chart options={barConfig.options} series={barConfig.series} type="bar" height={350} />
      </div>
    );
  }


  const hasValidData = (arr) =>
    Array.isArray(arr) && arr.length > 0 && arr.some(item => item.total > 0);

  const getSeries = (arr) => arr.map(i => i.total);
  const getLabels = (arr) => arr.map(i => i.categoryName);

  const sections = [
    { title: "Expenses", data: data.expenses },
    { title: "Direct Expenses", data: data.directExpenses },
    { title: "Indirect Expenses", data: data.indirectExpenses },
    { title: "Incomes", data: data.incomes },
    { title: "Direct Income", data: data.directIncome },
    { title: "Indirect Income", data: data.indirectIncome },
    { title: "Sales A/C", data: data.salesAccount }
  ];

  const validSections = sections.filter(sec => hasValidData(sec.data));

  if (validSections.length === 0) {
    return (
      <div className="bg-white p-10 text-center rounded-2xl border border-dashed border-gray-200 text-gray-400 mb-10">
        No chart data available for the selected period.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 mb-2">
      {validSections.map((sec, idx) => (
        <ChartCard
          key={idx}
          title={sec.title}
          series={getSeries(sec.data)}
          labels={getLabels(sec.data)}
        />
      ))}
    </div>
  );
};

export default ProfitLossChart;
